<template>
    <div class="park_box">
      <div class="park_list" v-for="(item,index) in parkList" :key="index">
        <p class="time">
          {{item.last_update}}
        </p>
        <div class="park_content">
          <p class="title">
            {{item.title}}
          </p>
          <div style="position: relative;">
            <div :class="{content:1,active:item.active}" >
<!--              {{item.content}}-->
             <p v-html="item.content"></p>
            </div>
            <div :class="{toggle_box:1,active:item.active}" @click="toggle(item)">
              <span>{{item.active ? '收起' : '展开'}}</span>
              <img src="../../assets/images/parkIndex/toggle_text.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      parkList: [
        {
          time: '2020.7.20',
          title: '7777广东省五大都市圈同时发力，钢铁风暴七月广东省五大都市圈同时发力，钢铁风暴七月',
          content: '在破解5月之谜的上一期，我们分析了两会之前各大项目赶工期，以及透支两会刺激政策预期导 在破解5月之谜的上一期，我们分析了两会之前 在破解5月之谜的上一期，我们分析了两会之前各大项目赶工期，以及透支两会刺激政策预期导 在破解5月之谜的上一期，我们分析了两会之前',
          img: require('../../assets/images/index/Carousel.jpg')
        },
        {
          time: '2020.6.29',
          title: '广311东省五大都市圈同时发力，钢铁风暴七月广东省五大都市圈同时发力，钢铁风暴七月',
          content: '在在破解5月之谜的上一期，我们分析了两会之前各大项目赶工期，以及透支两会刺激政策预期导 在破解5月之谜的上一期，我们分析了两会之前 在破解5月之谜的上一期，我们分析了两会之前各大项目赶工期，以及透支两会刺激政策预期导 在破解5月之谜的上一期，我们分析了两会之前破解5月之谜的上一期，我们分析了两会之前各大项目赶工期，以及透支两会刺激政策预期导 在破解5月之谜的上一期，我们分析了两会之前 在破解5月之谜的上一期，我们分析了两会之前各大项目赶工期，以及透支两会刺激政策预期导 在破解5月之谜的上一期，我们分析了两会之前',
          img: require('../../assets/images/index/Carousel.jpg')
        },
        {
          time: '2020.6.11',
          title: '广东省11五大都市圈同时发力，钢铁风暴七月广东省五大都市圈同时发力，钢铁风暴七月',
          content: '在破解在破解5月之谜的上一期，我们分析了两会之前各大项目赶工期，以及透支两会刺激政策预期导 在破解5月之谜的上一期，我们分析了两会之前 在破解5月之谜的上一期，我们分析了两会之前各大项目赶工期，以及透支两会刺激政策预期导 在破解5月之谜的上一期，我们分析了两会之前5月之谜的上一期，我们分析了两会之前各大项目赶工期，以及透支两会刺激政策预期导 在破解5月之谜的上一期，我们分析了两会之前 在破解5月之谜的上一期，我们分析了两会之前各大项目赶工期，以及透支两会刺激政策预期导 在破解5月之谜的上一期，我们分析了两会之前',
          img: ''
        },
        {
          time: '2020.5.20',
          title: '广东123省五大都市圈同时发力，钢铁风暴七月广东省五大都市圈同时发力，钢铁风暴七月',
          content: '在破解5月之谜的上一期，我们分析了两会之前各大项目赶工期，以及透支两会刺激政策预期导 在破解5月之谜的上一期，我们分析了两会之前 在破解5月之谜的上一期，我们分析了两会之前各大项目赶工期，以及透支两会刺激政策预期导 在破解5月之谜的上一期，我们分析了两会之前',
          img: ''
        }
      ]
    }
  },
  methods: {
    toggle (item) {
      item.active = !item.active
      this.$forceUpdate()
    }
  },
  mounted () {
    /* eslint-disable */
    /* 园区公告 */
    this.$axios(this.$API.NEWS_GETNEWSLISTS).then(({ data }) => {
      this.parkList = data.data.lists.map((item) => {
        return {
          article_id: item.article_id,
          article_short_desc: item.article_short_desc,
          article_type: item.article_type,
          author: item.author,
          cat_id: item.cat_id,
          content: item.content.replace(/<p[^>]*>/gi, '<p>')
            .replace(/<span[^>]*>/gi, '<span>')
            .replace(/<div[^>]*>/gi, '<div>')
            .replace(/<a[^>]*>/gi, '<a>')
            .replace(/\<img style\s*?=\s*?([‘"])[\s\S]*?\1/gi, '<img style="max-width:100%!important;height:auto;display:block!important;" ')
            .replace(/\<img/gi, '<img style="max-width:100%;height:auto" ').replace(/\<img/gi, '<img class="rich-img" '),
          last_update: item.last_update,
          notice_targets_type: item.notice_targets_type,
          professor_id: item.professor_id,
          title: item.title,
          topic_img: item.topic_img,
          user_auth: item.user_auth
        }
      })
    })
    /* eslint-disable */
  }
}
</script>

<style lang="less" scoped>
  .park_box{
    padding-bottom: 40px;
  }
  .park_list {
    padding: 0 24px;

    .time {
      color: #9b9b9b;
      height: 74px;
      line-height: 78px;
      font-size: 24px;
      text-align: center;
    }

    .park_content {
      background-color: #ffffff;
      border-radius: 20px;
      padding: 0 24px 54px 24px;

      .title {
        height: 80px;
        line-height: 86px;
        font-size: 32px;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .content {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        color: #9b9b9b;
        position: relative;
        font-size: 28px;
        p.one-p{
          font-size: 28px !important;
          color: #027cdf !important;
        }
      }

      .content.active {
        -webkit-line-clamp: 50;

        img {
          margin: 20px 0;
        }
      }

      .toggle_box {
        position: absolute;
        right: 0;
        bottom: -40px;
        color: #027cdf;
        display: flex;
        align-items: center;
      }

      .toggle_box.active {
        img {
          transform: rotate(180deg);
        }
      }
    }
  }

</style>
